import { Images } from '@/assets';
import { fonts } from '@/theme/fonts';
import styled from 'styled-components';

const AddressAndContact = () => {
  return (
    <Container>
      <Card>
        <Img src={Images.HqMegagenImg} alt="hq-megagen-img" />
        <Section>
          <AddressWrap>
            <Title>HQ</Title>
            <Address>45, Secheon-ro 7-gil Dasa-eup Dalseong-gun Daegu</Address>
          </AddressWrap>
          <NumberSection>
            <NumberWrap>
              <IconImg
                src={Images.HqPhoneIconImg}
                alt="customer-phone-icon-hq"
              />
              <div>+82-1544-2285</div>
            </NumberWrap>
            <NumberWrap>
              <IconImg src={Images.HqMailIconImg} alt="customer-mail-icon-hq" />
              <div>cs@imegagen.com</div>
            </NumberWrap>
          </NumberSection>
        </Section>
      </Card>
      <Card>
        <Img src={Images.EuMegagenImg} alt="eu-megagen-img" />
        <Section>
          <AddressWrap>
            <Title>EU</Title>
            <Address>Schijfstraat 26, 5061KB, Oisterwijk, Netherlands </Address>
          </AddressWrap>
          <NumberSection>
            <NumberWrap>
              <IconImg
                src={Images.EuPhoneIconImg}
                alt="customer-phone-icon-eu"
              />
              <div>+ 31 6 2534 6719</div>
            </NumberWrap>
            <NumberWrap>
              <IconImg src={Images.EuMailIconImg} alt="customer-mail-icon-eu" />
              <div>ingrida.plik@imegagen.com</div>
            </NumberWrap>
          </NumberSection>
        </Section>
      </Card>
    </Container>
  );
};

export default AddressAndContact;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Card = styled.div`
  border: 1px solid #e2e6f4;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);
  display: flex;
  color: #151131;
  width: 460px;
  box-sizing: border-box;
  display: flex;
`;

const Img = styled.img`
  border-radius: 8px 0 0 8px;
  max-width: 174px;
  width: 100%;
  height: 174px;
`;

const Section = styled.div`
  flex: 1;
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const AddressWrap = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 4px;
  padding-left: 8px;
`;

const Title = styled.div`
  font-weight: ${fonts.weight.bold};
  font-size: 20px;
  line-height: 140%;
`;

const Address = styled.div`
  font-size: 15px;
  line-height: 160%;
`;

const NumberSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const NumberWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 15px;
  line-height: 160%;
`;

const IconImg = styled.img`
  width: 24px;
  height: 24px;
`;
